// @ts-nocheck
import React, {useState} from "react";
import { t } from "i18next";
import { answerValue } from "classes/Forms/FormAnswerModel";

export default function FormTextOption({type, option, onChange, answers}) {
	const [value, setValue] = useState(answerValue(answers[0]) || "");

	function handleChange(val) {
		onChange({
			unique: true,
			...option,
			value: val
		});
		setValue(val);
	}

	return (
		<div className="">
			{
				type.type === "LongText" ?
					<textarea className="w-100" value={value} onChange={(e) => handleChange(e.target.value)} placeholder={t("Forms.ENTER_ANSWER")}/>
					:
					<input className="w-100" value={value} onChange={(e) => handleChange(e.target.value)} placeholder={t("Forms.ENTER_ANSWER")} type="text"/>
			}
		</div>
	);
}
